import * as React from "react";
import { CorrectionItem } from "../CorrectionItem";

export const SuppressSessionItem = ({ recordId, isDisabled, onClick, onRemove, correctionSelected }): JSX.Element => {
    return (
        <CorrectionItem
                recordId={recordId}
                title="Suppress / Unsuppress Session"
                description="Mark a session as either suppressed or not suppressed"
                isDisabled={isDisabled}
                onClick={onClick}
                onRemove={onRemove}
                correctionSelected={correctionSelected}
            />
    );
}
